import { ActionList, AnchoredOverlay, Box } from "@primer/react";
import { useMemo, useState } from "react";
import Button from "../button";
import { IComparisonOperator } from "./type/IDataGridProps";

const filterModes = [
  { id: "contains", name: "Chứa giá trị", icon: "../../images/search.svg" },
  { id: "equals", name: "So sánh bằng", icon: "../../images/equals.svg" },
  {
    id: "lessThanOrEqual",
    name: "Nhỏ hơn hoặc bằng",
    icon: "../../images/less-than.png",
  },
  {
    id: "greaterThanOrEqual",
    name: "Lớn hơn hoặc bằng",
    icon: "../../images/greater-than.png",
  },
];
interface IFilterModeSelectionProps {
  value?: IComparisonOperator;
  onChanged: (value: IComparisonOperator) => void;
}
const FilterModeSelection = (props: IFilterModeSelectionProps) => {
  const [isOpenOverlay, setIsOpenOverlay] = useState(false);
  const selectedValue = useMemo(() => {
    return filterModes.find((x) => x.id === props.value);
  }, [props.value]);
  const SelectedIcon = useMemo(() => {
    if (!selectedValue)
      return <img src={`../../images/search.svg`} style={{ width: "1rem" }} />;
    return <img src={`${selectedValue.icon}`} style={{ width: "1rem" }} />;
  }, [selectedValue]);
  return (
    <AnchoredOverlay
      open={isOpenOverlay}
      onClose={() => {
        setIsOpenOverlay(false);
      }}
      overlayProps={{
        role: "dialog",
        "aria-modal": true,
        "aria-label": "User Card Overlay",
      }}
      focusZoneSettings={{
        disabled: true,
      }}
      renderAnchor={(anchorProps) => {
        return (
          <Box {...anchorProps} tabIndex={-1}>
            <Button
              tabIndex={-1}
              onClick={() => {
                setIsOpenOverlay(true);
              }}
              sx={{
                backgroundColor: "transparent",
                border: 0,
                outline: 0,
              }}
            >
              {SelectedIcon}
            </Button>
          </Box>
        );
      }}
    >
      <Box sx={{ p: 2, width: "250px" }}>
        <ActionList showDividers selectionVariant="single" variant="full">
          {filterModes.map((filterMode) => {
            return (
              <ActionList.Item
                key={filterMode.id}
                selected={filterMode.id === selectedValue?.id}
                onSelect={() => {
                  props.onChanged(filterMode.id as any);
                }}
              >
                <ActionList.LeadingVisual>
                  <img src={`${filterMode.icon}`} style={{ width: "1rem" }} />
                </ActionList.LeadingVisual>
                {filterMode.name}
              </ActionList.Item>
            );
          })}
        </ActionList>
      </Box>
    </AnchoredOverlay>
  );
};

export default FilterModeSelection;
